var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"height":"100","width":"100"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"11","stroke":"#bdbdbd","stroke-width":"1","fill":"white"}}),_c('text',{attrs:{"x":"9","y":"15","font-size":"0.4em","fill":"black"}},[_vm._v("T")])])}
var staticRenderFns = []

export { render, staticRenderFns }